import {Component} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-guide.scss";
import {WebsiteBlackGuideNavComponent} from "./nav/WebsiteBlackGuideNavComponent";
import {WebsiteBlackGuideContentComponent} from "./content/WebsiteBlackGuideContentComponent";
import {WebsiteBlackGuideDetailsComponent} from "./details/WebsiteBlackGuideDetailsComponent";
import {IWebsitePostIncoming} from "../../../../../../models/website/posts/IWebsitePostIncoming";
import {Resources} from "../../../../../../resources/Resources";
import {IWebsitePostCategoryModel} from "../../../../../../models/website/posts/IWebsitePostCategoryModel";
import {IWebsitePostOverviewModel} from "../../../../../../models/website/posts/IWebsitePostOverviewModel";
import {Network} from "../../../../../../network/Network";

export class WebsiteBlackGuideComponent extends Component {

    public categories: IWebsitePostCategoryModel[];

    public nav: WebsiteBlackGuideNavComponent;
    public content: WebsiteBlackGuideContentComponent;
    public details: WebsiteBlackGuideDetailsComponent;

    public articleContainer: Component;
    public progressionContainer: Component;

    constructor(categories: IWebsitePostCategoryModel[]) {
        super();
        this.categories = categories;

        this.nav = new WebsiteBlackGuideNavComponent(categories);
        this.content = new WebsiteBlackGuideContentComponent();
        this.details = new WebsiteBlackGuideDetailsComponent();

        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackGuide}">
                <div class="${s.nav}">
                    ${this.draw(this.nav)}
                </div>
                <div class="${s.article}">
                    ${this.draw(this.content)}
                </div>
                <div class="${s.details}">
                    ${this.draw(this.details)}
                </div>
            </div>
        `;
    }

    commit() {
        this.articleContainer = this.el(s.article);

        super.commit();
    }

    removeProgression() {
        if (this.progressionContainer) {
            this.progressionContainer.remove();
            this.progressionContainer = undefined;
        }
    }

    renderProgression(nextPost: IWebsitePostOverviewModel, previousPost: IWebsitePostOverviewModel) {
        this.removeProgression();

        //language=HTML
        this.progressionContainer = this.articleContainer.append(`
            <div class="${s.progress}"></div>`);

        if (previousPost) {
            //language=HTML
            this.progressionContainer.append(`
                <a class="${s.button}"
                   href="${Network.router.pages.getUrlWithPath(`guide/${previousPost.route}`)}">
                    <div class="${s.icon}"></div>
                    ${Resources.t("words.previousGuide")}
                </a>
            `);
        }

        if (nextPost) {
            //language=HTML
            this.progressionContainer.append(`
                <a class="${s.button} ${s.next}"
                   href="${Network.router.pages.getUrlWithPath(`guide/${nextPost.route}`)}">
                    ${Resources.t("words.nextGuide")}
                    <div class="${s.icon}"></div>
                </a>
            `);
        }
    }
}